import {ColorGradientRestDto, ColorRestDto, ColorValueRestDto} from "@/api/pharma-cms-content-page/models";
import {ColorRestDtoModel} from "@/models/api/ColorRestDtoModel";
import {ColorGradientRestDtoModel} from "@/models/api/ColorGradientRestDtoModel";
import {BackgroundColorEnum} from "@/api/enums/background-color-enum";

export class ColorValueRestDtoModel implements ColorValueRestDto {
    color_code?: BackgroundColorEnum | null;
    rgba?: ColorRestDto | null;
    gradient?: ColorGradientRestDto | null;

    static createWithDefaults(): ColorValueRestDtoModel {
        return new this();
    }

    static cloneFrom(source: ColorValueRestDto): ColorValueRestDtoModel {
        const clone: ColorValueRestDtoModel = new this();

        clone.color_code = source.color_code;
        if (source.rgba) {
            clone.rgba = ColorRestDtoModel.cloneFrom(source.rgba);
        }
        if (source.gradient) {
            clone.gradient = ColorGradientRestDtoModel.cloneFrom(source.gradient);
        }

        return clone;
    }
}
